export default "__VITE_PUBLIC_ASSET__4fc93526__"